module.exports = __webpack_public_path__ + "static/media/graphql-schema.48feedc9.png";